export default "__VITE_ASSET__BWV298SG__"